export default __webpack_public_path__ + "static/media/ticket_set.ca285a33.svg";